import { useIntl } from 'react-intl'
import CustomTooltip from './CustomTooltip'
import { SUPPORT_CONTACT_EMAIL } from 'config'
import styled from 'styled-components'

interface Props {
  title: string
  position?: 'top' | 'bottom' | 'left' | 'right'
  onlyChildren?: boolean
  children: JSX.Element
}

export default function ContactSupportTooltip({
  title,
  position = 'top',
  onlyChildren = false,
  children,
}: Props): JSX.Element {
  const intl = useIntl()

  const renderTitle = () => {
    return (
      <>
        <div>{title}</div>
        <div>
          {intl.formatMessage({ id: 'strings.contact' })}: <SupportEmail>{SUPPORT_CONTACT_EMAIL}</SupportEmail>
        </div>
      </>
    )
  }

  if (onlyChildren) {
    return children
  }

  return (
    <CustomTooltip title={renderTitle()} position={position}>
      {children}
    </CustomTooltip>
  )
}

const SupportEmail = styled.span`
  color: #8a8a8a;
`
